/**
 * Primary pay CTA — the purple-gradient pill used by every checkout submit
 * button (new card, saved card, switch-card confirm, retry).
 */
export const payButtonClass =
  'h-[56px] w-full rounded-pill bg-gradient-to-b from-purple to-accent-dark text-lg font-semibold text-white shadow-card transition-opacity hover:opacity-90 active:opacity-80 disabled:pointer-events-none disabled:bg-none disabled:bg-ink-muted/30 disabled:text-white/70';

/** Card-detail input field — borderless soft lavender pill (per Figma). */
export const cardFieldClass =
  'h-[52px] rounded-pill border-0 bg-input-soft px-5 text-ink placeholder:text-ink-muted/60 focus-visible:ring-2 focus-visible:ring-purple/30';
